import React, {useState} from "react";

import moment from "moment";

import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormHelperText from "@material-ui/core/FormHelperText";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";

import {KeyboardDatePicker} from "@material-ui/pickers";

import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        "&:first-child": {
            marginLeft: 0,
        },
    },
    button: {
        height: "56px",
        margin: theme.spacing(1),
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));
const BookingReportsFilter = ({rooms, companies, query, setQuery, handleRequest}) => {
    const classes = useStyles();
    const [errors, setErrors] = useState({
        roomId: "",
        companyId: "",
        startDate: "",
        endDate: "",
    });
    const [inputValue, setInputValue] = React.useState("");

    const companyOptions = ["", ...companies.map((company) => company.id)];

    const handleChange = (event) => {
        setQuery((query) => {
            const updatedQuery = {...query};
            updatedQuery[event.target.name] = event.target.value;
            return updatedQuery;
        });
    };

    const handleSubmit = () => {
        setErrors((errors) => ({roomId: "", companyId: "", startDate: "", endDate: ""}));
        let errors = false;
        if (!moment(query.startDate).isValid()) {
            setErrors((errors) => ({...errors, startDate: "Invalid Date"}));
            errors = true;
        }
        if (!moment(query.endDate).isValid()) {
            setErrors((errors) => ({...errors, endDate: "Invalid Date"}));
            errors = true;
        }
        if (errors) return;
        handleRequest();
    };
    return (
        <div className={classes.container}>
            <FormControl variant="outlined" className={classes.formControl} error={!!errors.roomId}>
                <InputLabel id="room-label">Room</InputLabel>
                <Select
                    labelId="room-label"
                    id="room-select"
                    label="Room"
                    value={query.roomId}
                    onChange={handleChange}
                    name="roomId"
                >
                    <MenuItem key={`rooms-id-all`} value={""}>
                        All
                    </MenuItem>
                    {rooms.map((room) => (
                        <MenuItem key={`rooms-id-${room.id}`} value={room.id}>
                            {room.name}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>{errors.roomId}</FormHelperText>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl} error={!!errors.bookingStatus}>
                <InputLabel id="booking-status">Booking status</InputLabel>
                <Select
                    labelId="bookingStatus-label"
                    id="bookingStatus-select"
                    label="Booking Status"
                    value={query.bookingStatus}
                    onChange={handleChange}
                    name="bookingStatus"
                    required={true}
                >
                    <MenuItem key={`bookingStatus-COMPLETED`} value={"COMPLETED"}>
                        Completed bookings (past start date)
                    </MenuItem>
                    <MenuItem key={`bookingStatus-ALL`} value={"ALL"}>
                        All bookings
                    </MenuItem>
                </Select>
                <FormHelperText>{errors.bookingStatus}</FormHelperText>
            </FormControl>
            <Autocomplete
                value={query.companyId}
                id="company-select"
                options={companyOptions}
                style={{width: 300}}
                getOptionLabel={(option) => {
                    if (option === "") {
                        return "All";
                    } else {
                        const company = companies.find((company) => company.id === option);
                        return company.name;
                    }
                }}
                onChange={(event, newValue) => {
                    setQuery((query) => ({...query, companyId: newValue}));
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Company"
                        variant="outlined"
                        error={!!errors.companyId}
                        helperText={errors.companyId}
                        className={classes.formControl}
                        inputProps={{
                            ...params.inputProps,
                        }}
                    />
                )}
            />
            <KeyboardDatePicker
                className={classes.formControl}
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Start Date"
                format="DD/MM/yyyy"
                value={query.startDate}
                InputAdornmentProps={{position: "start"}}
                onChange={(date, value) => {
                    if (moment(date).isValid()) {
                        const strDate = date.format("DD/MM/YYYY");
                        const utcDate = moment.utc(strDate, "DD/MM/YYYY");
                        setQuery((query) => ({...query, startDate: utcDate.toDate()}));
                    } else {
                        const strDate = moment(date).format("DD/MM/YYYY");
                        const utcDate = moment.utc(strDate, "DD/MM/YYYY");
                        setQuery((query) => ({...query, startDate: utcDate.toDate()}));
                    }
                }}
                required={true}
                name="startDate"
                error={!!errors.startDate}
                helperText={errors.startDate}
            />
            <KeyboardDatePicker
                className={classes.formControl}
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="End Date"
                format="DD/MM/yyyy"
                value={query.endDate}
                InputAdornmentProps={{position: "start"}}
                onChange={(date, value) => {
                    if (moment(date).isValid()) {
                        const strDate = date.format("DD/MM/YYYY");
                        const utcDate = moment.utc(strDate, "DD/MM/YYYY");
                        setQuery((query) => ({...query, endDate: utcDate.toDate()}));
                    } else {
                        const strDate = moment(date).format("DD/MM/YYYY");
                        const utcDate = moment.utc(strDate, "DD/MM/YYYY");
                        setQuery((query) => ({...query, endDate: utcDate.toDate()}));
                    }
                }}
                error={!!errors.endDate}
                helperText={errors.endDate}
                name="endDate"
                required={true}
            />
            <Button
                onClick={handleSubmit}
                className={classes.button}
                variant="contained"
                disableElevation
                size="large"
                color="primary"
            >
                Request Data
            </Button>
        </div>
    );
};
export default BookingReportsFilter;
